export enum UnitsType {
    NUMBERS,
    PERCENTS,
    YEARS
}
export enum UnitsType {
    NUMBERS,
    PERCENTS,
    YEARS
}
